import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.payments.PaymentDetailsBankAccountInfo', {
    previous: 'Previous',
    actual: 'Actual',
    paymentMethod: 'Payment method:',
    entityType: 'Entity type:',
    bankCountry: 'Bank account country:',
    accountCurrency: 'Account currency:',
    bankAccountName: 'Account name:',
    accountNumber: 'Account number:',
    bicSwift: 'BIC / Swift code:',
    address: 'Address:',
    city: 'City:',
    country: 'Country:',
    postalCode: 'Postal code:',
    stateOrProvince: 'State / Province:',
    firstName: 'First name:',
    lastName: 'Last name:',
    companyName: 'Company name:',
    sortCode: 'Sort code:',
    aba: 'ABA:',
    bsb: 'BSB:',
    institutionNumber: 'Institution number:',
    incorporationNumber: 'Incorporation number:',
    bankCode: 'Bank code:',
    branchCode: 'Branch code:',
    clabe: 'CLABE:',
    cnaps: 'CNAPS:',
    iban: 'IBAN:',
    ifsc: 'IFSC code:',
    company: 'Company',
    individual: 'Individual',
});
